export const copyContent = async (value: string) => {
  if (typeof navigator === "undefined" || !navigator.clipboard) return false

  try {
    await navigator.clipboard.writeText(value)
    return true
  } catch (error) {
    console.error(error)
    return false
  }
}
